import { ThemeSelectors } from "@at/design-system-foundation";
import { BREAKPOINTS } from "@at/window-utils";
import styled from "styled-components";

import { PrintStyleSheet } from "../../seller/advert-seller-details/location/location.styles";

export const GallerySliderImage = styled.div``;

export const GallerySliderWrapper = styled.div``;

export const GallerySliderInner = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  scroll-snap-type: x mandatory;
  overflow: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  @media screen and (min-width: ${BREAKPOINTS.MEDIUM}px) {
    transition: none;
    scroll-behavior: auto;
  }
`;

export const GallerySliderItem = styled.div`
  position: relative;
  flex: 0 0 100%;
  box-sizing: border-box;
  scroll-snap-align: start;
  margin: 0;
`;

export const GallerySliderCounter = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: ${({ theme }) => ThemeSelectors.getWhite(theme)};
  padding: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
  line-height: 1;
  border-radius: ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)};
  ${PrintStyleSheet}
`;

export const GallerySliderControl = styled.button`
  display: block;
  background-color: rgb(255, 255, 255);
  border-radius: 100%;
  border: 0;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 2px 0px,
    rgba(0, 0, 0, 0.16) 0px 8px 8px -8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0;
  transition: fill 0.25s ease-in-out 0s;
  width: 40px;
  position: absolute;
  top: 50%;
  cursor: pointer;
  z-index: 2;
  ${PrintStyleSheet}

  @media screen and (max-width: ${BREAKPOINTS.MEDIUM - 1}px) {
    display: none;
  }

  &:focus-visible {
    outline: 4px auto ${({ theme }) => ThemeSelectors.getActionColor(theme)};
    > svg {
      fill: ${({ theme }) => ThemeSelectors.getActionColor(theme)};
    }
  }

  &:hover {
    > svg {
      fill: ${({ theme }) => ThemeSelectors.getActionColor(theme)};
    }
  }
`;

export const NextButton = styled(GallerySliderControl)`
  right: 16px;
  @media screen and (min-width: ${BREAKPOINTS.EXWIDE}px) {
    right: 80px;
  }
`;

export const PreviousButton = styled(GallerySliderControl)`
  left: 16px;
  @media screen and (min-width: ${BREAKPOINTS.EXWIDE}px) {
    left: 80px;
  }
`;
